import { inject, computed } from '@angular/core';
import { signalStore, withState, withComputed } from '@ngrx/signals';
import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { Events, withReducer, withEventHandlers } from '@ngrx/signals/events';
import { immerOn } from 'ngrx-immer/signals';
import { map } from 'rxjs';
import { User, userEvents } from '@kikkz/shared/user/util';
import { authEvents } from '@kikkz/shared/auth/util';

export interface UserState {
  user: User | null;
}

const initialUserState: UserState = {
  user: null,
};

export const UserStore = signalStore(
  withState(initialUserState),
  withDevtools('user'),
  withComputed((store) => ({
    isLoggedIn: computed(() => store.user() !== null),
    username: computed(() => store.user()?.username ?? null),
  })),
  withReducer(
    immerOn(userEvents.loadUserSuccess, (state, { payload }) => {
      state.user = payload.user;
    }),
    immerOn(userEvents.clearUser, (state) => {
      state.user = null;
    }),
  ),
  withEventHandlers((_, events = inject(Events)) => ({
    // Tenants feed this store by dispatching `userEvents.loadUserSuccess` from their own user
    // domain (b04: `B04UserStore`, effzeh: `EffzehRegistrationStore`).
    // Logout must clear the user; route it through the same `clearUser` reducer that
    // `UserFacade.clearUser()` uses, so "how the user gets cleared" stays defined once.
    clearOnLogout$: events.on(authEvents.logout).pipe(map(() => userEvents.clearUser())),
  })),
);
